var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 300,
    viewBox: "0 0 405 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.7 299.9C314.262 299.9 404.7 295.826 404.7 290.8C404.7 285.774 314.262 281.7 202.7 281.7C91.1385 281.7 0.700012 285.774 0.700012 290.8C0.700012 295.826 91.1385 299.9 202.7 299.9Z",
    fill: "#B2F5EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.2 288.8V24.1C291.2 23 290.3 22.1 289.2 22.1H94C92.9 22.1 92 23 92 24.1V288.8C92 289.9 92.9 290.8 94 290.8H289.2C290.3 290.8 291.2 289.9 291.2 288.8Z",
    fill: "#38B2AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.345 280.937L281.345 34.337L104.245 34.337L104.245 280.937H281.345Z",
    fill: "#319795"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.026 278.637L279.026 34.337L104.226 34.337L104.226 278.637H279.026Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.8 103H129.5V120.3H232.8V103Z",
    fill: "#81E6D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.8 145.6H129.5V162.9H232.8V145.6Z",
    fill: "#81E6D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7 145.6H248.3V163H265.7V145.6Z",
    fill: "#81E6D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.8 188.4H129.5V205.7H232.8V188.4Z",
    fill: "#81E6D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7 188.4H248.3V205.8H265.7V188.4Z",
    fill: "#81E6D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.8 231.1H129.5V248.4H232.8V231.1Z",
    fill: "#81E6D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7 231.1H248.3V248.5H265.7V231.1Z",
    fill: "#81E6D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.4 21.8L227.1 20.1L226.9 19.3L226.4 16.7L224.1 5.00001C223.5 2.10001 222 0.100006 220.2 0.100006H163.8C162 0.100006 160.5 2.10001 159.9 5.00001L157.6 16.7L157.1 19.3L156.9 20.1L156.6 21.8L155.7 26.1H228.3L227.4 21.8ZM192 13.7C190.3 13.7 188.8 12.3 188.8 10.5C188.8 8.80001 190.2 7.30001 192 7.30001C193.8 7.30001 195.2 8.70001 195.2 10.5C195.2 12.3 193.7 13.7 192 13.7Z",
    fill: "#38B2AC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.4 21.8H156.6L156.9 20.1L157 19.4H227L227.1 20.1L227.4 21.8Z",
    fill: "#319795"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.78 50.2854L129.792 66.7101L132.543 83.7904L234.531 67.3657L231.78 50.2854Z",
    fill: "#81E6D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 16.5C92.7 16.5 91.2 18 91.2 19.8L43 291C43 292.8 44.5 294.3 46.3 294.3C48.1 294.3 49.6 292.8 49.6 291L97.8 19.8C97.8 18 96.3 16.5 94.5 16.5Z",
    fill: "#B2F5EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147 16.5C145.2 16.5 143.7 18 143.7 19.8L95.5 291C95.5 292.8 97 294.3 98.8 294.3C100.6 294.3 102.1 292.8 102.1 291L150.3 19.8C150.3 18 148.8 16.5 147 16.5Z",
    fill: "#B2F5EA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 237.1H53.5V244.4H108.2V237.1Z",
    fill: "#B2F5EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.4 178.6H64.8V185.9H119.4V178.6Z",
    fill: "#B2F5EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.7 120.1H76.1V127.4H130.7V120.1Z",
    fill: "#B2F5EA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.1 61.6H87.5V68.9H142.1V61.6Z",
    fill: "#B2F5EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7 103H248.3V120.4H265.7V103Z",
    fill: "#81E6D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.2 77.6C195.2 77.6 195.1 73.7 195.7 73.2C196.6 72.3 198.6 70.3 198.8 70.3C199 70.3 199.3 70.8 199.3 71.2C199.2 71.6 198.6 73.2 198.6 73.2L204.6 72.2C204.6 72.2 203.7 74.9 202.6 76C202.3 76.3 198.4 79.8 198.4 79.8L195.2 77.6Z",
    fill: "#FFCEAB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 61.1C112.6 61.1 114.8 58 117 57.8C119.2 57.6 123.6 58.9 124.1 59.4C124.6 59.9 124.9 61.5 124.9 61.5H118.7L112.6 61.1Z",
    fill: "#FFCEAB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M126.4 101.1C126.4 101.1 109.2 88.6 106.9 79.6C104.9 71.9 110.4 60.7 112.6 61.1C114.8 61.6 117.4 65.2 117.4 65.2C117.4 65.2 115.7 69.4 116.5 72.8C118.5 81 135.2 87.2 135.2 87.2L137.8 90.9",
    fill: "#D1B1CB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.7 139.6C136.7 139.6 139.4 142.4 126.1 159.1C112 185.4 106.5 232.1 106.5 232.1H101.4C101.4 232.1 99.9 159.1 117.1 134.1L136.7 139.6Z",
    fill: "#0F1D29"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135 131.4C135 131.4 96.7 122.4 85.5 126.4C78.6 128.9 87 174.8 87 174.8H91.7C91.7 174.8 95.3 149 94.3 141.8C93.9 139.3 105.7 150.2 121.2 150.1C129 150 132.1 137.2 132.1 137.2L135 131.4Z",
    fill: "#152A3B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3 178.5C78.3 178.5 77.7 178.4 82.3 177C85.5 176.1 86.5 175.1 86.8 173.6H91.9C91.9 173.6 92.7 178.6 91.9 178.6C91.1 178.6 78.2 178.9 78.3 178.5Z",
    fill: "#152A3B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9 236.9C92.9 236.9 92.3 236.8 96.9 235.4C100.1 234.5 101.1 233.5 101.4 232H106.5C106.5 232 107.3 237 106.5 237C105.7 237.1 92.8 237.4 92.9 236.9Z",
    fill: "#0F1D29"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121 61.1C121 61.1 121.1 61.6 121.3 61.7C121.6 61.8 125.3 63 125.3 63.2C125.3 63.4 125.4 64.5 125.1 64.5C124.8 64.5 119.3 65.3 119 65.1C118.7 64.9 117.3 65.1 117.3 65.1L112.5 61C112.6 61.1 119.7 59.6 121 61.1Z",
    fill: "#FFCEAB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 102.7C143.6 105.1 147.1 111.4 149.5 111.8C153.2 112.4 166.2 110.3 176.6 105.7C187.1 101.1 200.3 82.8 198.8 79.3C198.2 78 196.3 77.1 195.1 77C194.5 76.9 194.4 77.2 194 77.7C191.4 81.2 179.5 90.5 175.9 92C170.6 94.3 160.6 94.7 150 92.3C142.9 90.7 141.7 95.6 143.1 102.7Z",
    fill: "#D1B1CB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 71.4C158.5 71.4 159.8 72.6 159.3 75.5C158.5 80 158.9 79 158.7 83.9C158.6 84.9 157 89.1 155.5 90.5C154.6 91.3 151.8 90.7 151.8 90.7C150.8 90.4 148 89.2 145.9 83.9C145.1 81.9 144.4 70.7 145.1 70.1C145.7 69.6 156.5 66.6 158.5 71.4Z",
    fill: "#FFCEAB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 92.1C141.2 92.1 143.9 84 145.5 80.8C147.1 77.6 148.3 79.7 148.3 79.7L152.1 84L150.3 94.3L141.2 92.1Z",
    fill: "#FFCEAB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 85.9C143.5 85.9 143.4 72.9 145 70.2C146.6 67.4 155 67.5 159.4 69.7C161.8 70.9 163.7 70.6 163.7 70.6C163.7 70.6 163.3 72.8 160.8 73.7C158.3 74.6 156.9 77.2 156.7 77.8C156.6 78.4 152.9 86 151.2 86.8C149.6 87.6 144.4 87.8 143.5 85.9Z",
    fill: "#152A3B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 106.7C158.1 116.1 141.5 140.6 136.6 142.3C125.6 146.2 109.5 130.1 112.9 127.3C119.2 122.2 117.8 117.3 123.9 102C129 89.2 134.1 86.7 135.2 87.2C155.1 95.8 164.3 91.5 160.5 106.7Z",
    fill: "#D1B1CB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155 81.5C155 81.5 155 79.1 154 79.1C153 79 152 83.1 152.5 83.6C153 84.1 154 84.2 154 84.2L155 81.5Z",
    fill: "#FFCEAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.38bb8347.svg";
export { ForwardRef as ReactComponent };